import { type FC, Fragment } from 'react';
import { graphql, useFragment } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import { filterNulls } from 'dibs-ts-utils/exports/filterNulls';
import { PARTIALLY_LINKABLE_LINK } from 'dibs-elements/exports/SeoLink';

import { type QuickViewCreatorsV2_quickViewDisplay$key } from './__generated__/QuickViewCreatorsV2_quickViewDisplay.graphql';

const quickViewDisplayFragment = graphql`
    fragment QuickViewCreatorsV2_quickViewDisplay on QuickViewDisplayType {
        creators {
            displayName
            linkData {
                ...SeoLink_linkData
            }
        }
    }
`;

type Props = {
    quickViewDisplay: QuickViewCreatorsV2_quickViewDisplay$key | null;
};

export const QuickViewCreators: FC<Props> = ({ quickViewDisplay: quickViewDisplayRef }) => {
    const quickViewDisplay = useFragment(quickViewDisplayFragment, quickViewDisplayRef);

    const creators = (quickViewDisplay?.creators ?? []).filter(filterNulls);

    return creators?.length ? (
        <p data-tn="quick-view-creators">
            <FormattedMessage
                id="dibs-buyer-product-tile.QuickViewCreator.by"
                defaultMessage="By "
            />
            {creators.map((creator, index) => (
                <Fragment key={creator.displayName}>
                    <SeoLink
                        variant={PARTIALLY_LINKABLE_LINK}
                        linkData={creator.linkData}
                        dataTn="quick-view-creator-link"
                    >
                        {creator.displayName}
                    </SeoLink>
                    {index < creators.length - 1 ? ', ' : null}
                </Fragment>
            ))}
        </p>
    ) : null;
};
